import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RecommendModel} from '../../../shared/models/recommend.model';

@Injectable({providedIn: 'root'})
export class RecommentCandidateCompanyService {
    constructor(private http: HttpClient) {
    }
    // create recommend candidate request
    createRecommendationCandidate(recommendCandidate: object) {
        // HTTP Request
        return this.http.post<RecommendModel>('agri/createRecommendation', recommendCandidate)
    }
    // display recommend candidate request
    displayAllRecommandatation(recommendCandidate: object){
        return this.http.get<RecommendModel>('agri/getAllRecommendations', recommendCandidate)
    }

    // create recommend company request
    createRecommendationCompany(recommendCompany: object) {
        // HTTP Request
        return this.http.post<RecommendModel>('agri/createRecommendation', recommendCompany)
    }
}
